/**
 * assets/svea-installment.js
 *
 * Visar lägsta månadskostnad + ⓘ-knapp som öppnar en accordion
 * med alla delbetalningsplaner i Sveas format.
 *
 * Villkor bekräftade av Svea:
 *   3 / 6 / 12 mån  → 0% ränta
 *   24 / 36 / 60 mån → 9,95% nominell årsränta
 */

(function () {
  'use strict';

  var PLANS = [
    { months: 60, rate: 0.0995 },
    { months: 36, rate: 0.0995 },
    { months: 24, rate: 0.0995 },
    { months: 12, rate: 0      },
    { months: 6,  rate: 0      },
    { months: 3,  rate: 0      },
  ];

  function calcMonthly(price, months, rate) {
    if (rate === 0) return Math.ceil(price / months);
    var r = rate / 12;
    return Math.ceil(
      (price * r * Math.pow(1 + r, months)) / (Math.pow(1 + r, months) - 1)
    );
  }

  function fmt(n) {
    return n.toLocaleString('sv-SE') + '\u00a0kr';
  }

  function buildPlans(price) {
    return PLANS.map(function (p) {
      var monthly = calcMonthly(price, p.months, p.rate);
      var total   = monthly * p.months;
      return {
        months:      p.months,
        rate:        p.rate,
        monthly:     monthly,
        total:       total,
        interestFree: p.rate === 0,
      };
    });
  }

  function renderAccordion(container, plans) {
    var html = plans.map(function (p) {
      var rateLabel = p.interestFree ? '0% ränta' : '9,95% ränta';
      return (
        '<div class="svea-plan-row' + (p.interestFree ? ' svea-plan-row--free' : '') + '">' +
          '<span class="svea-plan-row__count">' + p.months + ' betalningar</span>' +
          '<span class="svea-plan-row__monthly"><em>' + p.monthly.toLocaleString('sv-SE') + ' kr</em> per månad</span>' +
          '<span class="svea-plan-row__rate">' + rateLabel + '</span>' +
          '<span class="svea-plan-row__total">Totalt ' + fmt(p.total) + '</span>' +
        '</div>'
      );
    }).join('');

    container.querySelector('.svea-accordion__plans').innerHTML = html;
  }

  function initWidget(widget) {
    if (widget.dataset.initialized) return;
    widget.dataset.initialized = 'true';

    var price = parseInt(widget.dataset.price, 10);
    if (!price || isNaN(price)) return;

    var plans      = buildPlans(price);
    var lowestPlan = plans.slice().sort(function (a, b) { return a.monthly - b.monthly; })[0];

    /* Sätt lägsta månadskostnad i raden */
    widget.querySelector('.svea-widget__lowest').textContent =
      lowestPlan.monthly.toLocaleString('sv-SE') + '\u00a0kr';

    /* Bygg accordion-innehåll */
    renderAccordion(widget, plans);

    /* Toggle */
    var btn       = widget.querySelector('.svea-widget__toggle');
    var accordion = widget.querySelector('.svea-accordion');

    btn.addEventListener('click', function () {
      var isOpen = !accordion.hidden;
      accordion.hidden = isOpen;
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  }

  function initAll() {
    document.querySelectorAll('.svea-widget').forEach(initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.svea-widget').forEach(function (w) {
      delete w.dataset.initialized;
    });
    initAll();
  });

  /* Variantbyte — anropa när kunden byter variant */
  window.SveaWidget = {
    update: function (newPriceKr) {
      document.querySelectorAll('.svea-widget').forEach(function (w) {
        delete w.dataset.initialized;
        w.dataset.price = Math.round(newPriceKr);
        w.querySelector('.svea-accordion').hidden = true;
        w.querySelector('.svea-widget__toggle').setAttribute('aria-expanded', 'false');
      });
      initAll();
    },
  };

})();
